<header class="header-navbar" [class.not-home]="!isHome" [class.no-shadow]="isEcommerce || isRealEstateSearch" [class.no-fixed]="isEcommerceProductList">
  <div class="header-container">
    <div class="nav-container">
      <nav class="navbar">
        <app-button innerId="btn-Bx5pnWMP" label="Menú" styleClass="secondary dark" icon="hamburger-menu" (action)="showMenuSidebar()" />
        <app-button innerId="btn-Ldp9gqaB" label="¿Qué es Mundo Hogar?" styleClass="tertiary dark" routerLink="/what-is-mundo-hogar" />
      </nav>
      <div class="logo-container">
        <a class="link" routerLink="/" id="btn-link-t826lA0j"><div class="logo animate__fadeIn"></div></a>
      </div>
      <div class="right-container" [class.show]="firstLoadFinished" [class.animate__fadeIn]="firstLoadFinished">
        @if(!isEcommerce && (hasFavorites || (shoppingCartDetail && shoppingCartDetail.totalItems))) {
          <div class="entity-container">
            <a class="custom-button-clear" routerLink="/ecommerce/my-favorites" id="btn-link-HwBw3J9Y">
              <i class="icon-heart icon badge-container">
                @if (hasFavorites) {
                  <span class="badge"></span>
                }
              </i>
            </a>
            <a class="custom-button-clear" routerLink="/ecommerce/shopping-cart" id="btn-link-EWRZhNvI">
              <i class="icon-supermarket-cart icon cart badge-container">
                @if (shoppingCartDetail && shoppingCartDetail.totalItems) {
                  <span class="badge">{{ shoppingCartDetail.totalItems }}</span>
                }
              </i>
            </a>
          </div>
        }
        @if (user && user.enrollmentStatus === 'done') {
          <div class="avatar-container">
            <div class="user-info">
              <p class="greeting">Hola 👋</p>
              <p class="user-name" data-private>{{ user.name }}</p>
            </div>
            <div class="avatar" (click)="overlayPanel.toggle($event)" id="btn-link-VsmwzkAU">{{ userNameInitials }}</div>
          </div>
        } @else {
          @if (user && user.enrollmentStatus === 'pending') {
            <app-button innerId="btn-epQDZCd_" label="Completar" styleClass="secondary" routerLink="/enrollment" />
          } @else {
            <app-button innerId="btn-qifipqQG" label="Ingresar" styleClass="primary" routerLink="/enrollment/sign-in" />
          }
        }
      </div>
    </div>
  </div>
</header>
<div class="header-spacer" [class.no-spacer]="isEcommerceProductList"></div>
@if ((!isEcommerce && !isEnrollment && !isPrivateSite && !isRealEstate) && (hasFavorites || (shoppingCartDetail && shoppingCartDetail.totalItems))) {
  <div class="fixed-wrapper">
    <div class="helpful-entity-container">
      <div class="helpful-entity">
        <i class="icon-heart icon badge-container" routerLink="/ecommerce/my-favorites">
          @if (hasFavorites) {
            <span class="badge"></span>
          }
        </i>
        <i class="icon-supermarket-cart icon cart badge-container" routerLink="/ecommerce/shopping-cart">
          @if (shoppingCartDetail && shoppingCartDetail.totalItems) {
            <span class="badge">{{ shoppingCartDetail.totalItems }}</span>
          }
        </i>
      </div>
    </div>
  </div>
} @else if (isEcommerce) {
  <div class="entity-complementary-bar">
    <div class="search-input-container">
      <app-ecommerce-search-input [query]="ecommerceQuery" (inputClick)="openEcommerceSearch()" />
    </div>
    <div class="entity-complementary-container">
      <div class="main-wrapper">
        <div class="left-controls">
          @if (isEcommerceProductList) {
            <button class="custom-button-clear filters" (click)="openEcommerceFilters()">Filtros
              <i class="icon icon-filter badge-container">
                @if (hasActiveEcommerceFilters) {
                  <span class="badge"></span>
                }
              </i>
            </button>
          } @else if (isEcommerceProductDetail) {
            <button class="custom-button-clear back" (click)="goBack()"><i class="pi pi-angle-left icon"></i></button>
          }
        </div>
        <app-ecommerce-search-input class="search-input" [query]="ecommerceQuery" [searchHistory]="ecommerceSearchHistory" (searchClick)="searchEcommerce($event)" (deleteHistoryClick)="deleteEcommerceSearchHistory()" (changeQuery)="changeEcommerceQuery($event)" />
        <div class="right-controls">
          @if (showSearchIcon) {
            <button class="custom-button-clear search" (click)="openEcommerceSearch()"><i class="icon-search icon"></i></button>
          }
          <a class="custom-button-clear" routerLink="/private-site/my-purchases"><i class="icon-shopping-bag icon"></i></a>
          <a class="custom-button-clear" routerLink="/ecommerce/my-favorites">
            <i class="icon-heart icon badge-container">
              @if (hasFavorites) {
                <span class="badge"></span>
              }
            </i>
          </a>
          <a class="custom-button-clear" routerLink="/ecommerce/shopping-cart">
            <i class="icon-supermarket-cart icon cart badge-container">
              @if (shoppingCartDetail && shoppingCartDetail.totalItems) {
                <span class="badge">{{ shoppingCartDetail.totalItems }}</span>
              }
            </i>
          </a>
        </div>
      </div>
    </div>
    <div class="entity-bar-spacer"></div>
    <ng-container>
      <ng-content></ng-content>
    </ng-container>
  </div>
}
@if (isRealEstateSearch) {
  <div class="entity-complementary-bar">
    <div class="search-input-container">
      <app-real-estate-search-input [query]="realEstateQuery ?? ''" (inputClick)="openRealEstateSearch()" />
    </div>
    <div class="entity-complementary-container">
      <div class="main-wrapper">
        <div class="left-controls">
          <button class="custom-button-clear filters" (click)="openRealEstateFilters()">Filtros
            <i class="icon icon-filter badge-container">
              @if (hasActiveRealEstateFilters) {
                <span class="badge"></span>
              }
            </i>
          </button>
        </div>
        <app-real-estate-search-input class="search-input" [query]="realEstateQuery ?? ''" (queryChange)="realEstateQuery = $event" (submit)="searchRealEstate($event)" />
        <div class="right-controls">
          @if (showSearchIcon) {
            <button class="custom-button-clear search" (click)="openRealEstateSearch()"><i class="icon-search icon"></i></button>
          }
          <!-- TODO: disabled until real estate favorites are implemented -->
          <!--<a class="custom-button-clear" routerLink="/ecommerce/my-favorites">
            <i class="icon-heart icon badge-container">
              @if (hasFavorites) {
                <span class="badge"></span>
              }
            </i>
          </a>-->
        </div>
      </div>
    </div>
    <div class="entity-bar-spacer"></div>
    <ng-container>
      <ng-content></ng-content>
    </ng-container>
  </div>
}

<app-menu-sidebar [categories]="ecommerceCategories" [visible]="menuSidebarVisible" (closed)="closedMenuSidebar()" id="btn-link-nDL8kpzv" />
<p-overlayPanel #overlayPanel>
  <ng-template pTemplate="content">
    <app-button innerId="btn-lC9969JT" label="Mis servicios" (action)="goTo('/private-site')" styleClass="tertiary dark" />
    <app-button innerId="btn-6awjUhOU" label="Mis favoritos" (action)="goTo('/ecommerce/my-favorites')" styleClass="tertiary dark" />
    <app-button innerId="btn-_RfJ2APO" label="Mi carrito de compras" (action)="goTo('/ecommerce/shopping-cart')" styleClass="tertiary dark" />
    <app-button innerId="btn-RROcWIVC" label="Mis datos personales" (action)="goTo('/private-site/profile/my-personal-data')" styleClass="tertiary dark" />
    <app-button innerId="btn-AO7vpEa7" label="Cerrar sesión" (action)="signOut()" styleClass="tertiary dark" />
  </ng-template>
</p-overlayPanel>
<app-ecommerce-filter-sidebar #ecommerceFilterSidebar [categories]="ecommerceCategories" [category]="ecommerceCategory" [filtersQueryParams]="ecommerceFilters" [orderQueryParams]="ecommerceOrder" (changeFilters)="filterEcommerce($event)" (hasActiveFilters)="changeEcommerceFilters($event)" />
<app-ecommerce-search-sidebar #ecommerceSearchSidebar [query]="ecommerceQuery" [searchHistory]="ecommerceSearchHistory" (searchClick)="searchEcommerce($event)" (deleteHistoryClick)="deleteEcommerceSearchHistory()" (changeQuery)="changeEcommerceQuery($event)" />
<app-real-estate-filter-sidebar #realEstateFilterSidebar [values]="realEstateFilterValues" (changeFilters)="filterRealEstate($event)" (hasActiveFilters)="changeRealEstateFilters($event)" />
<app-real-estate-search-sidebar #realEstateSearchSidebar [query]="realEstateQuery ?? ''" (queryChange)="realEstateQuery = $event" (submit)="searchRealEstate($event)" />
